<template>
  <div style="display: none;">
    <!-- This component doesn't render anything visible -->
  </div>
</template>

<script>
export default {
  name: 'SEOImageOptimizer',
  mounted () {
    this.optimizeImages()
  },
  methods: {
    optimizeImages () {
      // Add lazy loading attributes
      this.addLazyLoading()
    },

    addLazyLoading () {
      // Add lazy loading to all images
      const images = document.querySelectorAll('img')
      images.forEach(img => {
        if (!img.hasAttribute('loading')) {
          img.setAttribute('loading', 'lazy')
        }
        if (!img.hasAttribute('decoding')) {
          img.setAttribute('decoding', 'async')
        }
      })
    }
  }
}
</script>
